import { Route } from '@angular/router';

export const routes: Route[] = [
  // Redirect root to sign-in
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/sign-in',
  },

  // Auth
  {
    path: 'auth',
    loadChildren: () => import('./domains/auth/routes'),
  },

  // Admin
  {
    path: 'admin',
    loadChildren: () => import('./domains/admin/routes'),
  },

  // Coming soon
  {
    path: 'coming-soon',
    loadChildren: () => import('./domains/coming-soon/routes'),
  },
];
